// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  sessionId: __t.u64().primaryKey().name("session_id"),
  userIdentity: __t.identity().name("user_identity"),
  deviceInfo: __t.option(__t.string()).name("device_info"),
  ipAddress: __t.option(__t.string()).name("ip_address"),
  connectedAt: __t.timestamp().name("connected_at"),
  lastActive: __t.timestamp().name("last_active"),
});
